<template>
  <div>
    <pl-dialog padding="2em 4em" height="450px">
      <!-- HEADER -->
      <div class="flex justify-between pv2">
        <div class="tc w-100">
          <span class="b header-title" style="font-size: 20px">
            {{ course_title }}</span
          >
          <span
            v-if="!course.is_archived"
            @click="goToCourse"
            class="course-link justify-center items-center"
          >
            <a class="flex justify-center items-center" target="_blank">
              Go to this course <i class="fas fa-external-link-alt"></i> </a
          ></span>
        </div>
      </div>
      <!--- Container -->
      <div v-if="loaded_course" class="flex flex-column">
        <div class="primary-teacher pv2 ph4">
          <span class="field-header b"> Primary Teachers </span>
          <multiselect
            v-model="selected_teacher"
            :options="teachers"
            :multiselect="false"
            :selected="selected_teacher"
            label="name"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            track-by="id"
            :limit="1"
            class="border-select"
            placeholder="Select teacher"
            style="max-width: 100%"
          >
          </multiselect>
        </div>
        <div class="co-teacher pv2 ph4">
          <span class="field-header b"> Co-teacher(s) </span>
          <multiselect
            v-model="selected_co_teachers"
            :options="teachers"
            :multiple="true"
            :selected="selected_co_teachers"
            label="name"
            :max-height="150"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            track-by="id"
            :limit="1"
            placeholder="Select co-teacher(s)"
            style="max-width: 100%"
          >
            <template slot="selection" slot-scope="{ values, search, isOpen }">
              <span
                class="multiselect__single"
                v-if="selected_co_teachers.length>1 &amp;&amp; !isOpen"
              >
                {{ selected_co_teachers.length }} co-teachers selected
              </span>
            </template>
          </multiselect>
        </div>
        <!-- <div class="primary-teacher pv2 ph4">
          <span class="field-header b"> Subject </span>
          <pl-select
            :options="course_mock.subjects"
            :selected="course_mock.selected_subject"
            class="border-select"
            placeholder="Select subject"
          >
          </pl-select>
        </div> -->
        <!--         <div class="primary-teacher pv2 ph4">
          <span class="field-header b"> School/Site </span>
          <pl-select
            :options="course_mock.sites"
            :selected="course_mock.site"
            class="border-select"
            placeholder="Select site"
          >
          </pl-select>
        </div> -->
      </div>
      <!--- Submit Buttons -->
      <div
        class="flex justify-center items-center pv3"
        style="padding-top: 150px"
        v-if="loaded_course"
      >
        <pl-button @click.native="$emit('close')">CANCEL</pl-button>

        <pl-button
          @click.native="updateCourseTeachers"
          :disabled="teachers_changed || same_teacher_co_teacher"
          class="pl-primary"
        >
          Save
        </pl-button>
      </div>
    </pl-dialog>
  </div>
</template>

<script>
  import Multiselect from 'vue-multiselect';
  import adminServices from 'services/admin/adminServices';
  import { mapGetters } from 'vuex';
  import { EventBus } from 'utils/event-bus';
  import courseDetailsService from 'services/courses';
  import URLconfigs from 'services/apiConfigs';

  export default {
    components: {
      Multiselect,
    },
    data() {
      return {
        course: null,
        selected_co_teachers: [],
        selected_teacher: null,
        teacher: null,
        co_teachers: [],
        loaded_course: false,
      };
    },
    props: {
      courseSelected: {
        type: Object,
        default: null,
      },

      teachers: {
        type: Array,
        default() {
          return [];
        },
      },
    },
    computed: {
      ...mapGetters(['getProfile']),
      course_title() {
        return this.courseSelected ? this.courseSelected.title : 'Course';
      },
      same_teacher() {
        if (this.courseSelected.teacher) {
          return this.courseSelected.teacher.id === this.selected_teacher.id;
        }
        return false;
      },
      same_coteachers() {
        const selected = this.selected_co_teachers.map((co_t) => co_t.id);
        if (this.courseSelected.co_teachers) {
          const previous = this.course.co_teachers.map((co_t) => co_t.id);
          return this.arraysAreIdentical(selected, previous);
        }
        return false;
      },
      hasTeacherPermissions() {
        const user_id = this.getProfile.id;
        return (
          (this.courseSelected.teacher &&
            this.courseSelected.teacher.id === user_id) ||
          (this.courseSelected.co_teachers &&
            this.courseSelected.co_teachers
              .map((co_t) => co_t.id)
              .includes(user_id))
        );
      },
      teachers_changed() {
        return this.same_coteachers && this.same_teacher;
      },
      same_teacher_co_teacher() {
        if (this.selected_co_teachers.length && this.selected_teacher) {
          return (
            this.selected_co_teachers.find(
              (t) => t.id === this.selected_teacher.id
            ) !== undefined
          );
        }
        return false;
      },
    },
    methods: {
      updateCourseTeachers() {
        const teacher_id = this.same_teacher ? null : this.selected_teacher.id;
        const co_teachers_ids = this.same_coteachers
          ? null
          : this.selected_co_teachers.map((co_t) => co_t.id);
        const course_title = this.course.title;
        const payload = {
          teacher_id,
          co_teachers_ids,
          course_title,
        };
        adminServices
          .updateCourseTeacherCoTeachers(this.course.id, payload)
          .then(() => {
            EventBus.$emit(
              'toast-msg',
              'Success! Course Teachers were updated!'
            );
            EventBus.$emit('updateCoursesList');
            this.$emit('close');
          })
          .catch(() => {
            EventBus.$emit('toast-msg', 'Error! Please try again!');
          });
      },
      arraysAreIdentical(arr1, arr2) {
        if (arr1.length !== arr2.length) return false;
        for (var i = 0, len = arr1.length; i < len; i++) {
          if (arr1[i] !== arr2[i]) {
            return false;
          }
        }
        return true;
      },
      getCourseDetails() {
        this.course = this.courseSelected;
        adminServices
          .getTeacherOfCourse(this.$route.params.schoolID, this.course.id)
          .then(({ data }) => {
            if (data.length) {
              this.course.teacher = data.find((t) => t.role === 'author');
              this.selected_teacher = this.course.teacher;
              this.course.co_teachers = data.filter(
                (t) => t.role == 'co-teacher'
              );
              this.selected_co_teachers = this.course.co_teachers;
            }
          })
          .catch(() => {
            EventBus.$emit(
              'toast-msg',
              'Error loading course. Please try again.'
            );
          })
          .finally(() => {
            this.loaded_course = true;
          });
      },
      goToCourse() {
        const courseID = this.courseSelected.id;
        const url = `${URLconfigs.uiURL}/classes/${courseID}?page=1`;
        //should count course admins in the future
        if (!this.hasTeacherPermissions) {
          courseDetailsService
            .createAdminSubscription(courseID, {
              school_id: this.$route.params.schoolID,
            })
            .then(() => {
              window.open(url, '_blank');
            })
            .catch(() => {
              EventBus.$emit(
                'toast-msg',
                'Something went wrong...Please try again.'
              );
              return;
            });
        } else {
          window.open(url, '_blank');
        }
      },
    },
    created() {
      this.course = this.courseSelected;
      this.getCourseDetails();
    },
    mounted() {
      this.course = this.courseSelected;
    },
  };
</script>

<style lang="stylus" scoped>
  @import '~app/global-stylus.styl';
  /deep/ .multiselect__tags
    border-radius:0px !important
  /deep/ .multiselect-container
    /deep/ .multiselect__content-wrapper
      max-height:200px !important
  .field-header
    color:pl-secondary
    font-size:15px
  .header-title
    color:pl-secondary
    font-size:20px
  .course-link
    cursor:pointer
    a
      color pl-primary
      :hover
        text-decoration underline
      i
        align-self start
        font-size 6px
        padding 4px
</style>



// WEBPACK FOOTER //
// courseDetailsModal.vue?41fc43c0